module.exports = __webpack_public_path__ + "static/img/certificate_train_jzcg_t.bfee5e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate_train_jzcg_t.png
// module id = aaHh
// module chunks = 0